import MmmCircularTTBookTtf from 'fonts/3MCircularTT-Book.ttf';
import MmmCircularTTBookWoff from 'fonts/3MCircularTT-Book.woff';
import MmmCircularTTBookWoff2 from 'fonts/3MCircularTT-Book.woff2';

export const colors = {
    alertsStandardSuccess: '#008726',
    alertsStandardInfo: '#2661ea',
    alertsStandardWarning: '#b86217',
    alertsStandardError: '#bf0000',
    colors1Primary: '#fff000',
    colors4TextPrimary: 'rgba(38, 38, 40, 0.23)',
    colors5Success: '#40a84e',
    colors6Error: '#db3333',
    colors7Warning: '#ee7002',
    secondary: '#000000',
    colors2Secondary: '#00a1cf',
    fillBlue05: '#e6f1fd',
    fillBlue50: '#2661ea',
    fillBlue60: '#386bcd',
    fillLightBlue70: '#006696',
    fillGray03: '#f8f8fa',
    fillGray10: '#e4e4e8',
    fillGray30: '#b4b4b8',
    fillGray60: '#76767a',
    fillGray70: '#656569',
    fillGray80: '#4c4c4f',
    fillGray92: '#323234',
    fillGray94: '#262628',
    fillRed50: '#bf0000',
    fillRed70: '#b71f1f',
    fillRed10: '#ff9999',
    fillGreen: '#1e4620',
    fillGreen05: '#e6f8eb',
    fillGreen50: '#008726',
    fillOrange05: '#fef3e9',
    fillOrange50: '#b86217',
    fillOrange70: '#963308',
    fillBlue00Brand: '#003ce6',
    fillWhite: '#ffffff',
    fillLandingGray: '#f0f2f3',
    fillDisabledIconGray: '#eeeeee',
    fillLandingTitleGray: '#aeaeae',
    fillYellow00Brand: '#fff000',
    fillYellow05: '#fffee6',
    facebookBlue: '#3B5998',
    microsoftGray: '#737373'
};

export const spacing = [4, 8, 12, 16, 20, 24, 32, 40, 48, 64];

export const fonts = [{
    fontFamily: '"3MCircularTT"',
    fontStyle: 'normal',
    fontDisplay: 'swap',
    fontStretch: 'normal',
    fontWeight: 'normal',
    src: `
        url(${MmmCircularTTBookWoff2}) format('woff2'), 
        url(${MmmCircularTTBookWoff}) format('woff'), 
        url(${MmmCircularTTBookTtf}) format('truetype');
    `
}];

